import { conditionApi, entityOrderApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { OrderEntityType } from 'constants/orderEntityType';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const CONDITION_ACTION_TYPE = createNamedActions('conditions', {
  GET_CONDITIONS: 'GET_CONDITIONS',
  GET_CONDITION: 'GET_CONDITION',
  ADD_CONDITION: 'ADD_CONDITION',
  DELETE_CONDITION: 'DELETE_CONDITION',
  UPDATE_CONDITION: 'UPDATE_CONDITION',
  REORDER_CONDITIONS: 'REORDER_CONDITIONS',
});

const conditions = new schema.Entity('conditions', {}, { idAttribute: 'id' });

export const getConditionsAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await conditionApi.getCondition();

  return dispatch({
    type: CONDITION_ACTION_TYPE.GET_CONDITIONS,
    payload: normalize(data, [conditions]).entities.conditions,
  });
});

export const getConditionByIdAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await conditionApi.getConditionByConditionId(params);

  return dispatch({
    type: CONDITION_ACTION_TYPE.GET_CONDITION,
    payload: data,
  });
});

export const addConditionAction = catchAsyncActionError(body => async dispatch => {
  const { data } = await conditionApi.createCondition(body);

  return dispatch({
    type: CONDITION_ACTION_TYPE.ADD_CONDITION,
    payload: data,
  });
});

export const updateConditionAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await conditionApi.editCondition(params);

  return dispatch({
    type: CONDITION_ACTION_TYPE.UPDATE_CONDITION,
    payload: data,
  });
});

export const deleteConditionAction = catchAsyncActionError(({ conditionId }) => async dispatch => {
  await conditionApi.deleteCondition({ conditionId });

  return dispatch({
    type: CONDITION_ACTION_TYPE.DELETE_CONDITION,
    payload: conditionId,
  });
});

export const reorderConditionsLocallyAction =
  ({ list }) =>
  dispatch => {
    dispatch({
      type: CONDITION_ACTION_TYPE.REORDER_CONDITIONS,
      payload: list,
    });
  };

export const reorderConditionsAction = catchAsyncActionError(
  ({ orderedEntityIds }) =>
    async dispatch => {
      dispatch(reorderConditionsLocallyAction({ list: orderedEntityIds }));

      return await entityOrderApi.createOrder({
        orderedEntityType: OrderEntityType.CONDITION,
        orderedEntityIds,
      });
    },
);
